import React from 'react'

import './PersonalBlock.css'

const PersonalBlock = ({ person }) => (
  <div className="personal-block">
    <div className="personal-block__face">
      <img src={require(`./img/${person.faceURL}`)} alt={person.name} />
    </div>
    <div className="personal-block__name">{person.name}</div>
    <div className="personal-block__title">{person.title}</div>
  </div>
)

export default PersonalBlock



// WEBPACK FOOTER //
// ./src/Components/PersonalBlock/PersonalBlock.js